import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { StoresButtons } from "../StoresButtons";
import { palette } from "../../config";
import chroma from "chroma-js";
import { useTranslation } from "react-i18next";
import { legalUrls } from "../../helpers/legalUrls";

function Footer() {
  const { t, i18n } = useTranslation();
  
  // Get the correct policy file paths based on current language
  const getPolicyPath = (policyType: 'privacy' | 'cookie') => {
    const lang = i18n.language;
    const suffix = lang === 'en' ? '_en' : '';
    return `/policy/${policyType}_policy${suffix}.html`;
  };
  
  return (
    <footer
      className="text-white text-center text-lg-start pt-4"
      style={{
        backgroundImage: `linear-gradient(120deg, ${chroma(
          palette.primary
        ).alpha(1)}, ${chroma(palette.secondary).alpha(0)} 30%)`,
      }}
    >
      <div className="container">
        

        {/* Contenuto del footer */}
        <div className="row">
          <div className="col-12 col-md-12 mb-12 d-flex justify-content-center">
            <div>
                <img
                  src="/assets/logo.png"
                  alt="EffAI"
                  style={{
                    objectFit: "contain",
                    height: "2.5rem",
                    marginBottom: "1rem",
                  }}
                />
              </div>
          </div>

          {/* Link utili */}
          {<div className="col-12 col-md-4 mb-4">
            <h6>
              <strong>{t('footer.usefulLinks')}</strong>
            </h6>
            <ul className="list-unstyled">
              {/* <li>
                <a
                  href="/terms-and-conditions" // TODO
                  className="text-white text-decoration-none"
                >
                  Termini e condizioni
                </a>
              </li> */}
              <li>
                <a
                  href={getPolicyPath('privacy')}
                  className="text-white text-decoration-none"
                >
                  {t('footer.privacyPolicy')}
                </a>
              </li>

              <li>
                <a
                  href={getPolicyPath('cookie')}
                  className="text-white text-decoration-none"
                >
                  {t('footer.cookiePolicy')}
                </a>
              </li>

              <li>
                <a
                  href={legalUrls.RELAZIONE_SOSTENIBILITA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  {t('footer.impactReport2025')}
                </a>
              </li>
            </ul>
          </div> }

          {/* Contatti */}
          <div className="col-12 col-md-4 mb-4">
            <h6>
              <strong>{t('footer.contacts')}</strong>
            </h6>
            <ul className="list-unstyled">
              <li>
                <i className="fas fa-location-dot me-2"></i>{t('footer.address')}
              </li>
              <li>
                <i className="fas fa-envelope me-2"></i>{t('footer.email')}
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-4 mb-4">
            
            <h6>
              <strong>{t('footer.companyName')}</strong>
            </h6>
            <ul className="list-unstyled">
              <li>
                {t('footer.vatNumber')}
              </li>
              <li>
                {t('footer.madeWith')} <i className="fas fa-heart"></i> {t('footer.madeLocation')}
              </li>
            </ul>
          </div>

        </div>

        {/* Sezione social */}
        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mb-4">
          <div className="d-flex gap-3">
            <a
              href="https://www.linkedin.com/company/108260606/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn linkedin"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/effai_tech"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn instagram"
              title="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>


        {/* Copyright */}
        <div className="text-center py-3 border-top">
          <small>{new Date().getFullYear()} {t('footer.copyright')}</small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
